'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography, useTheme } from '@mui/material';
const SortButtonGroup = ({ options, selectedValue, onChange }) => {
    const theme = useTheme();
    const groupedOptions = options.reduce((acc, option) => {
        if (!acc[option.category]) {
            acc[option.category] = [];
        }
        acc[option.category].push(option);
        return acc;
    }, {});
    return (_jsx(Box, { sx: { display: 'flex', flexDirection: 'column', p: 1 }, children: Object.entries(groupedOptions).map(([category, categoryOptions]) => (_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '12px', borderBottom: `1px solid ${theme.palette.divider}`, pb: '12px', children: [_jsx(Typography, { variant: 'subtitle2', color: 'textPrimary', sx: { mb: 1 }, children: category }), _jsx(Box, { sx: { display: 'flex', gap: 2 }, children: categoryOptions.map((option) => {
                        const isSelected = selectedValue === option.value;
                        return (_jsx(Button, { variant: 'outlined', size: 'medium', fullWidth: true, onClick: () => onChange(option.value), sx: {
                                borderRadius: '8px',
                                height: '40px',
                                textTransform: 'none',
                                fontWeight: 'normal',
                                backgroundColor: isSelected ? 'rgba(142, 51, 255, 0.08)' : 'transparent',
                                borderColor: isSelected ? 'primary.main' : theme.palette.divider,
                                color: isSelected ? 'primary.dark' : 'rgba(99, 115, 129, 1)',
                                '&:hover': {
                                    backgroundColor: isSelected
                                        ? 'rgba(124, 58, 237, 0.12)'
                                        : 'rgba(0, 0, 0, 0.04)',
                                    borderColor: isSelected ? 'primary.main' : theme.palette.divider
                                }
                            }, children: option.label }, option.value));
                    }) })] }, category))) }));
};
export default SortButtonGroup;
